import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import {userLogout,forbiddenAccess} from  './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
    .use(function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
            console.log('UnAuthorized');
              userLogout();
                
            }else if(res.status === 403){
              console.log('Forbidden');
              forbiddenAccess();
            }
        });
});


export function getServicesStart() {
  return {
    type: types.GET_SERVICES_START,
  };
}

export function getServicesSuccess({ services, staffMembers }) {
  return {
    type: types.GET_SERVICES_SUCCESS,
    services,
    staffMembers,
  };
}

export function getServicesFail(ex) {
  return {
    type: types.GET_SERVICES_FAIL,
    error: ex.message,
  };
}

export function setCategories({ categories }) {
  return {
    type: types.SET_SERVICE_CATEGORIES,
    categories,
  };
}

export const lookupStaffMembers = (ids, members) => {
  return (members || []).filter((member) => {
    return (ids || []).includes(member.id);
  });
};

export function getServices() {
  return (dispatch, getState) => {
    const { business} = getState();
    dispatch(getServicesStart());
    (business.id
      ? Promise.resolve(business.id)
      : request
          .get(`${window.Config.API_URL}/business/studioId`).withCredentials().set('X-Request-ID', uuidv4())
          .then((resp) => {
            return resp.body.data.id;
          })
    )
      .then((businessId) => {
        return Promise.all([
          request.get(
            `${window.Config.API_URL}/business/dental/services`,
          ).withCredentials().set('X-Request-ID', uuidv4()),
          request.get(`${window.Config.API_URL}/business/dental/staffs`).withCredentials().set('X-Request-ID', uuidv4()),
        ]);
      })
      .then((resp) => {
        const services = Array.isArray(resp[0].body) ? resp[0].body : [];
        const members = resp[1].body;
        dispatch(
          getServicesSuccess({
            staffMembers: members,
            services: (services || []).map((service) => {
              return {
                ...service,
                category: service.ancestor_id,
                staff: lookupStaffMembers(service.staff_ids, members),
              };
            }),
          }),
        );
      })
      .catch((ex) => {
        dispatch(getServicesFail(ex));
      });
  };
}

export function getCategories() {
  return (dispatch, getState) => {
    const { business } = getState();
    request
      .get(
        `${window.Config.API_URL}/business/dental/services/categories`,
      ).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(setCategories({ categories: resp.body }));
      })
      .catch((ex) => {
        dispatch(getServicesFail(ex));
      });
  };
}

export function saveService(service) {
  return (dispatch, getState) => {
    dispatch(getServicesStart());
    const { services, business } = getState();
    (service.id
      ? request
          .put(
            `${window.Config.API_URL}/business/dental/services/${service.id}`,
          ).withCredentials().set('X-Request-ID', uuidv4())
          .send(
            Object.assign(service, {
              bookable: true,
              business_id: business.id,
              ancestor_id: service.category,
              capacity: 1,
              cost: 0,
              tags: service.tags || [],
              duration: `PT${service.hours}H${service.mins}M`,
              total_duration: `PT${service.hours}H${service.mins}M`,
              image_url: '',
              notes: '',
              pricing: [],
              resource_ids: [],
              locations: [],
              service_ids: [],
            }),
          )
          .then(() => {
            const idx = services.list.findIndex((m) => {
              return m.id === service.id;
            });
            services.list[idx] = {
              ...service,
              staff: lookupStaffMembers(
                service.staff_ids,
                services.staffMembers,
              ),
            };
            dispatch(
              getServicesSuccess({
                services: services.list,
                staffMembers: services.staffMembers,
              }),
            );
          })
      : request
          .post(`${window.Config.API_URL}/business/dental/services`).withCredentials().set('X-Request-ID', uuidv4())
          .send(
            Object.assign(service, {
              id: `SC-${business.id}-ST-${parseInt(Math.random() * 10000, 10)}`,
              bookable: true,
              business_id: business.id,
              ancestor_id: service.category,
              capacity: 1,
              cost: 0,
              tags: service.tags || [],
              duration: `PT${service.hours}H${service.mins}M`,
              total_duration: `PT${service.hours}H${service.mins}M`,
              image_url: '',
              notes: '',
              pricing: [],
              resource_ids: [],
              locations: [],
              service_ids: [],
            }),
          )
          .then(() => {
            services.list.push({
              ...service,
              staff: lookupStaffMembers(
                service.staff_ids,
                services.staffMembers,
              ),
            });
            dispatch(
              getServicesSuccess({
                services: services.list,
                staffMembers: services.staffMembers,
              }),
            );
          })
    ).catch((ex) => {
      dispatch(getServicesFail(ex));
    });
  };
}

export function removeService(id) {
  return (dispatch, getState) => {
    dispatch(getServicesStart());
    const { services, business } = getState();
    const idx = services.list.findIndex((m) => {
      return m.id === id;
    });
    if (idx !== -1) {
      request
        .delete(
          `${window.Config.API_URL}/business/dental/services/${id}`,
        ).withCredentials().set('X-Request-ID', uuidv4())
        .then(() => {
          services.list.splice(idx, 1);
          dispatch(
            getServicesSuccess({
              services: services.list,
              staffMembers: services.staffMembers,
            }),
          );
        })
        .catch((ex) => {
          dispatch(getServicesFail(ex));
        });
    }
  };
}
